import { useVerificationDataQuery } from '../../../graphql/generated/graphql'

export const useEntityStatus = () => {
    const { data, loading } = useVerificationDataQuery()

    const canAddBills = !!data?.me?.methodFiEntity?.canReceive
    const canAuthenticate = !!data?.me?.methodFiEntity?.canRetrieveData

    const canAutoFindBills = canAddBills && canAuthenticate

    return {
        loading,
        canAddBills,
        canAutoFindBills,
    }
}
